import React from "react";
import { Button } from "../../../../designSystem/button/Button";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { PageHeader } from "../../../../designSystem/PageHeader";
import { P } from "../../../../designSystem/typography/Body";
import { H2 } from "../../../../designSystem/typography/Heading";


export function IncidentWorkInjury():JSX.Element
{
    
    return (
        <Flex flexDirection='column' gap={32}>
            <PageHeader 
                headerIcon='record_voice_over'
                headerText={`Indberetning af - Arbejdsskade `} />
            <Flex flexDirection="column" gap={16}>
                <P>
                Hvis uheldet er ude, er det essentielt at arbejdsmiljøorganisationen indmelder arbejdsulykken, og efterfølgende får bearbejdet denne i fællesskab.
                </P>
            </Flex>

            <Flex flexDirection="column" gap={16}>
                <H2>Indmeld skaden til virk.dk</H2>
                <P>
                    Det er vigtigt at få indberettet arbejdsskaden til virk.dk, efter gældende regler. På denne måde bliver der sat gang i de lovpligtige omstændigheder for arbejdsulykker, til gavn for den tilskadekomne og virksomhedens samarbejde med det offentlige ift. sagen.
                </P>
                <Flex justifyContent="center">
                    <Button 
                        variant="filled" 
                        onClick={ () => window.open('https://virk.dk/myndigheder/stat/AES/selvbetjening/Anmeldelse_af_arbejdsulykke/', '_blank')}
                        text="Indberetning til virk.dk" />
                </Flex>
            </Flex>

        </Flex>
    );


    

}